const grey = {
  300: "#868cb2",
  500: "#585f82",
  600: "#464c68",
  700: "#2d3555",
};

export default grey;
